export default [
    {
        // 全部消息（菜单入口）
        path: '/pages/message/messageBoxList',
        name: '/pages/message/messageBoxList',
        component: () => import('@/views/message/messageBoxList.vue'),
        props: { status: 'all' },
        meta: { title: '全部消息' }
    },
    {
        // 未读消息（菜单入口）
        path: '/pages/message/messageUnreadList',
        name: '/pages/message/messageUnreadList',
        component: () => import('@/views/message/messageBoxList.vue'),
        props: { status: 'unread' },
        meta: { title: '未读消息' }
    },
    {
        // 已读消息（菜单入口）
        path: '/pages/message/messageReadList',
        name: '/pages/message/messageReadList',
        component: () => import('@/views/message/messageBoxList.vue'),
        props: { status: 'read' },
        meta: { title: '已读消息' }
    }
]
